
import Swiper from 'swiper/swiper-bundle.min'
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import 'swiper/swiper-bundle.min.css'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      swiperInstance: null,
      currentSlideIndex: 0,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.padding = this.getBreakpointValue(this.blok.padding)

      return styles
    },
    controlsStyles() {
      const styles = {}

      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.padding = this.getBreakpointValue(this.blok.padding)

      return styles
    },
    labelsContainerStyles() {
      const styles = {}

      styles.maxWidth = this.getBreakpointValue(
        this.blok.labelsContainerMaxWidth
      )
      styles.margin = this.getBreakpointValue(this.blok.labelsContainerMargin)

      return styles
    },
    slidesContainerStyles() {
      const styles = {}

      styles.background = this.blok.slidesContainerBackground
      styles.margin = this.getBreakpointValue(this.blok.slidesContainerMargin)

      return styles
    },
  },

  mounted() {
    this.$nextTick(() => {
      const mm = this.$gsap.matchMedia(this.$el)

      // desktop
      mm.add('(min-width: 1024px)', () => {
        this.initSwipers()
      })
    })
  },
  methods: {
    initSwipers() {
      this.$gsap.context(() => {
        this.swiperInstance = new Swiper(this.$refs.carousel, {
          // loop: true,
          effect: 'creative',
          creativeEffect: {
            prev: {
              //   shadow: true,
              translate: [0, 0, -400],
              opacity: 0,
            },
            next: {
              translate: ['100%', 0, 0],
            },
          },
          // effect: 'fade',
          // fadeEffect: {
          //   crossFade: true, // Set crossFade to true for a smoother fade transition
          //   duration: 300, // Set the duration of the fade transition in milliseconds
          // },
          grabCursor: true,
          keyboard: true,
          mousewheel: {
            enabled: true,
            eventsTarget: this.$refs.carousel,
            releaseOnEdges: true,
            thresholdDelta: 0.5,
            thresholdTime: 150,
            forceToAxis: true,
            invert: false,
            sensitivity: 0.5,
            modifiers: {
              axis: 'x',
              delta: 0.5,
              factor: 1,
              invert: false,
              pixelRatio: 1,
              velocity: 0.3,
            },
          },
          speed: 800,
          on: {
            realIndexChange: (swiper) => {
              this.changeSlideIndex(swiper.activeIndex)
            },
          },
        })

        this.swiperInstance.on('mousewheel', (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            event.preventDefault()
            this.swiperInstance.translateTo(
              -this.swiperInstance.translate + event.deltaX * 2,
              0,
              0
            )
          }
        })
      }, this.$refs.container)
    },

    changeSlideIndex(index) {
      this.swiperInstance.slideTo(index) // Use the slideTo method to navigate to the specified index
      this.currentSlideIndex = index
    },

    toggleBackgroundColor(event, state) {
      if (state) {
        // enter - hover state
        this.$gsap.to(event.target, {
          backgroundColor: this.blok.hoverBackgroundColor,
          // color: this.backgroundColor,
          duration: 0.1,
        })
      } else if (
        !state &&
        Number(event.target?.dataset?.index) !== this.currentSlideIndex
      ) {
        // leave - default state if not active
        this.$gsap.to(event.target, {
          backgroundColor: this.blok.labelBackgroundColor,
          // color: this.textColor,
          duration: 0.1,
        })
      }
    },
  },
}
